export enum CertificateTranscriptTemplateType {
  WithCoatOfArms = 'WITH_COAT_OF_ARMS',
  WithoutCoatOfArms = 'WITHOUT_COAT_OF_ARMS',
}
